// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const ContestList = lazy(() => import('pages/contest/contestList'));
const ContestCreate = lazy(() => import('pages/contest/contestCreate'));
const ContestEdit = lazy(() => import('pages/contest/contestEdit'));
const ContestShow = lazy(() => import('pages/contest/contestShow'));

const FrequencyRoute = (
  <Route path={routeName.contest}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CONTEST_VIEW,
            PrivateRouteConst.SELF_CONTEST_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ContestList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={[PrivateRouteConst.CREATE_CONTEST]}>
          <Suspense fallback={<Loading />}>
            <ContestCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CONTEST_EDIT,
            PrivateRouteConst.SELF_CONTEST_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ContestEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.CONTEST_VIEW,
            PrivateRouteConst.SELF_CONTEST_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ContestShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default FrequencyRoute;
